






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {Banner} from '@/model/resource/Banner'
import {InputBannerSchema} from '@/schema/resource/Banner/InputBannerSchema'

@Component
export default class PersistBannerView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputBannerSchema()
  banner = new Banner()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.banner.getBanner(id)
    }

    $.await.done('getBanner')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.banner.persistBanner()
    await Helper.successAndPush('system.success.persist', '/banner/list')
  }
}
